
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/siteindex",
      function () {
        return require("private-next-pages/siteindex/index.js");
      }
    ]);
  